import { useQuery } from '@tanstack/react-query'
import { dashboardApi } from '@/api/dashboard'
import { MetricCard } from './MetricCard'
import {
	Package,
	ShoppingCart,
	DollarSign,
} from 'lucide-react'

export function SupplierDashboard() {
	const { data: products } = useQuery({
		queryKey: ['dashboard', 'supplier', 'products'],
		queryFn: dashboardApi.getSupplierProducts,
	})

	const { data: orders } = useQuery({
		queryKey: ['dashboard', 'supplier', 'orders'],
		queryFn: dashboardApi.getSupplierOrders,
	})

	const { data: settlement } = useQuery({
		queryKey: ['dashboard', 'supplier', 'settlement'],
		queryFn: dashboardApi.getSupplierSettlement,
	})

	return (
		<div className="space-y-6">
			<div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
				<MetricCard
					title="供应商品"
					value={products?.total ?? 0}
					icon={Package}
				/>
				<MetricCard
					title="总订单"
					value={orders?.total ?? 0}
					icon={ShoppingCart}
				/>
				<MetricCard
					title="待结算金额"
					value={`¥${(settlement?.pending_amount ?? 0).toFixed(2)}`}
					icon={DollarSign}
				/>
				<MetricCard
					title="已结算金额"
					value={`¥${(settlement?.settled_amount ?? 0).toFixed(2)}`}
					icon={DollarSign}
				/>
			</div>

			<div className="grid gap-4 lg:grid-cols-2">
				<div className="bg-card rounded-lg border p-6">
					<h3 className="text-lg font-semibold mb-4">商品销量</h3>
					<div className="space-y-2">
						{products?.items?.map((p) => (
							<div key={p.product_id} className="flex items-center justify-between py-2 border-b last:border-0">
								<span className="text-sm">{p.product_name}</span>
								<div className="flex items-center gap-4 text-sm">
									<span className="text-muted-foreground">库存: {p.stock}</span>
									<span className="font-semibold">销量: {p.sales_count}</span>
								</div>
							</div>
						))}
						{(!products?.items || products.items.length === 0) && (
							<p className="text-sm text-muted-foreground text-center py-4">暂无商品数据</p>
						)}
					</div>
				</div>

				<div className="bg-card rounded-lg border p-6">
					<h3 className="text-lg font-semibold mb-4">最近订单</h3>
					<div className="space-y-2">
						{orders?.recent_list?.map((o) => (
							<div key={o.order_no} className="flex items-center justify-between py-2 border-b last:border-0">
								<div>
									<p className="text-sm font-medium">{o.order_no}</p>
									<p className="text-xs text-muted-foreground">{o.product_name} × {o.quantity}</p>
								</div>
								<div className="text-right">
									<p className="text-sm font-semibold">¥{o.total_amount.toFixed(2)}</p>
									<p className="text-xs text-muted-foreground">{o.created_at}</p>
								</div>
							</div>
						))}
						{(!orders?.recent_list || orders.recent_list.length === 0) && (
							<p className="text-sm text-muted-foreground text-center py-4">暂无订单数据</p>
						)}
					</div>
				</div>
			</div>
		</div>
	)
}
